<template>
  <div class="page">
    <!-- 遮罩 -->
    <div class="mask"></div>

    <!-- 弹窗 -->
    <div class="popup" :style="{ marginTop: `${popup_top}px` }">
      <!-- 弹窗内容 -->
      <div class="popup-content">
        <!-- 背景 -->
        <div class="content-bg">
          <img src="@/assets/images/YuliApp/intro/pic_bg.png" />
        </div>

        <!-- 文字内容 -->
        <div class="content-text">
          <div class="pos content-text-name longTouch">{{ localesPackage?.['kudasai_christmas_rules']?.[localesEnv] }}</div>

          <div class="pos content-text-body">
            {{ localesPackage?.['kudasai_christmas_content2']?.[localesEnv] }}
            <!-- <div class="text">
              {{ localesPackage?.['kudasai_christmas_label']?.[localesEnv] }}
              <p>
                {{ localesPackage?.['kudasai_christmas_content1']?.[localesEnv] }}
            </p>
              </div>
              <p>
                {{ localesPackage?.['kudasai_christmas_content2']?.[localesEnv] }}
              </p> -->
            <!-- <div class="text">
              <p class="text-content longTouch">
                <span class="blod">Campaign Cut-off Time:</span> <br/>
                2023/2/10 00:00 UTC+0 - 2023/2/23 00:00 UTC+0<br/>
              </p>
              <p class="text-content longTouch">
               <span class="blod">Campaign Rule:</span> <br/>
                Every Time you collect 5 Bouquet of Roses,you will get a chance to spin the SpinWin with Kana,who will give you a random reward.The Bouquet of Roses can only be obtained through purifying Terras.
              </p>
              <p class="text-content longTouch">
                <span class="blod">Gift List:</span><br/>
                Precious Ryutaro SR+ Magic Card<br/>
                Valentine Limited Kana PFPs<br/>
                EXP Packages<br/>
                Basic Resonance Scroll(20%)<br/>
                Breed Tickets<br/>
              </p>
            </div> -->
          </div>
        </div>
      </div>

      <!-- 弹窗按钮 -->
      <div class="popup-btn" @click="handleClose">
        <img
          src="@/assets/images/YuliApp/storageActivity/icon_delete_nor@2x.png"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from "vue";
import hookStoreState from "@/utils/useState.js";
// import { PRIZE_LIST } from "../../constants/storagePrize.js";
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState({
      languageEnv: (state) => state.global.languageEnv,
      languagePackage: (state) => state.global.languagePackage,
    }),
  },
  watch: {
    languageEnv: {
      async handler(value) {
        if(value){
          this.localesEnv = value;
        }
      },
      immediate: true,
      deep: true,
    },
    languagePackage: {
      async handler(value) {
        if(value){
          this.localesPackage = value;
        }
      },
      immediate: true,
      deep: true,
    }
  },
  setup(props, ctx) {
    /**语言包 - ref */
    const localesPackage = ref({});
    /**语言环境 - ref */
    const localesEnv = ref('en');
    const storeStateObj = hookStoreState({
      init: (state) => state.global.init,
      statusBarHeight: (state) => state.global.statusBarHeight,
    });
    const { statusBarHeight } = storeStateObj;
    const popup_top = ref(
      statusBarHeight.value + window.innerHeight * 0.1 - 20
    );
    // const prize_list = ref([]);
    onMounted(() => {
      // prize_list.value = PRIZE_LIST;
    });

    /**
     * 处理关闭
     */
    const handleClose = () => {
      ctx.emit("close", false);
    };

    return {
      popup_top,
      handleClose,
      localesPackage,
      localesEnv
      // prize_list,
    };
  },
};
</script>

<style lang="less" scoped>
//阻止长按操作
.longTouch {
  -webkit-touch-callout: none; /*系统默认菜单被禁用*/
  -webkit-user-select: none; /*webkit浏览器*/
  -khtml-user-select: none; /*早期浏览器*/
  -moz-user-select: none; /*火狐*/
  -ms-user-select: none; /*IE10*/
  user-select: none;
}
.blod{
  font-weight: 600;
}
p {
  margin: 0;
  padding: 0;
}
.page {
  width: 100%;
  height: 100%;
  margin-top: -60px;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 999;

  .mask {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    top: 0;
    left: 0;
  }

  .popup {
    width: 351px;
    // margin-top: 128px; // 84
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    img {
      width: 100%;
      height: 100%;
    }

    &-content {
      width: 100%;

      .content {
        &-bg {
          width: 351px;
          height: 495px;
        }

        &-text {
          color: #626e8f;
          font-size: 15px;
          font-weight: 400;
          font-family: "PingFang SC";
          text-align: left;
          
          .pos {
            position: absolute;
            left: 0;
            right: 0;
            margin: 0 auto;
          }

          &-name {
            top: 37px;
            font-size: 18px;
            font-weight: 500;
            text-align: center;
            line-height: 22px;
          }

          &-body {
            top: 104px;
            width: 241px;
            padding-left: 10px;
            font-size: 15px;
            line-height: 20px;
            overflow-y:scroll;
            height: 350px;
            white-space: pre-line;
            .text {
              margin-bottom: 22px;
              &-title {
                color: rgba(98, 110, 143, 1);
                font-size: 16px;
                font-weight: 600;
                font-family: "PingFang SC";
                text-align: left;
                line-height: 20px;
                margin-bottom: 3px;
              }
              &-content {
                // padding-left: 12px;
                color: rgba(98, 110, 143, 1);
                font-size: 14px;
                font-weight: 400;
                font-family: "PingFang SC";
                text-align: left;
                line-height: 20px;
              }
              p{
                  margin: 10px 0;
                }
            }
          }
        }
      }
    }

    &-btn {
      // margin-top: 28px;
      position: absolute;
      z-index: 999;
      bottom: -70px;
      width: 40px;
      height: 40px;
    }
  }
}
@media screen and (max-height: 670px) {
  .page {
    .popup {
      margin-top: 25px !important;
      &-btn {
        position: absolute;
        z-index: 999;
        bottom: -0;
        width: 40px;
        height: 40px;
      }
    }
  }
}
@media screen and (min-width: 480px) {
  .page {
    .popup {
      margin-top: 25px !important;
      &-btn {
        position: absolute;
        z-index: 999;
        bottom: 20px;
        width: 40px;
        height: 40px;
      }
    }
  }
}
</style>
